export const REPORTS_QUERY_KEY = ['reports'] as const;
export const REPORT_DETAIL_QUERY_KEY = (id: string) => ['reports', id] as const;
export const REPORT_ELEMENT_DATA_QUERY_KEY = ['reports', 'element-data'] as const;
export const REPORT_ELEMENT_DATA_PAGINATED_QUERY_KEY = [
  'reports',
  'element-data-paginated',
] as const;
export const REPORT_AVAILABLE_COLUMNS_QUERY_KEY_ROOT = ['reports', 'columns'] as const;
export const REPORT_AVAILABLE_COLUMNS_QUERY_KEY = (dataSource: string | null) =>
  [...REPORT_AVAILABLE_COLUMNS_QUERY_KEY_ROOT, dataSource] as const;
export const FORMULA_ENTRIES_QUERY_KEY = ['formula-library'] as const;
